import api from '../../api/index'
export default {
  addI18nMessages (context, messages) {
    return new Promise((resolve) => {
      context.commit('ADD_I18N_MESSAGES', messages)
      resolve()
    })
  },
  loadLanguageGroup (context, obj) {
    context.commit('default/SET_LOADING', { flag: true, message: 'loading_wording' }, { root: true })
    return new Promise((resolve) => {
      api.request('get', 'assets/i18n/' + obj.locale + '/' + obj.group + '.json', {})
        .then(response => {
          context.commit('ADD_I18N_MESSAGES', JSON.parse(JSON.stringify(response.data)))
          resolve()
          context.commit('default/SET_LOADING', { flag: false, message: '' }, { root: true })
        })
        .catch(error => {
          console.log(error)
        })
    })
  }
}
/* $.getJSON('http://not-so-stupid.com/php/getJson.php?url=/assets/i18n/' + obj.group + '_' + obj.locale + '.json&' + Math.random(), json => {
 context.commit('ADD_I18N_MESSAGES', json)
 resolve()
 context.commit('default/SET_LOADING', {flag: false, message: ''}, { root: true })
 })
 }) */
